<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <validated-dropdown-input
                v-if="projects && projects.length > 0"
                :options="projectNames"
                v-model="projectname"
                label="Project"
                name="projectname"
                placeholder="select a project"
                :clearable="true"
              />
            </div>

            <div class="md-layout-item md-small-size-100 md-size-40">
              <validated-dropdown-input
                v-model="pilotfullname"
                :key="projectname + pilotfullname"
                :options="pilots"
                @input="onPilotSelected"
                label="Pilot"
                name="pilotfullname"
                placeholder="select a pilot"
                validation-rules="required"
                :value-transformation="
                  item =>
                    `${item.firstname}|${item.lastname}|${item.email}|${item.phone}`
                "
                :display-transformation="
                  item => `${item.firstname} ${item.lastname}`
                "
              />
            </div>

            <label
              class="md-layout-item md-small-size-100 md-size-10 md-form-label"
            >
              {{ $t("Pilot License") }}
            </label>
            <div class="md-layout-item md-small-size-100 md-size-40">
              <md-field>
                <md-input v-model="pilotlicense" type="text" disabled />
              </md-field>
            </div>

            <div class="md-layout-item md-small-size-100 md-size-40">
              <validated-dropdown-input
                v-model="observername"
                :key="projectname + observername"
                :options="observers"
                label="Observer"
                name="observername"
                placeholder="select an observer"
                :value-transformation="
                  item => `${item.firstname} ${item.lastname}`
                "
                :display-transformation="
                  item => `${item.firstname} ${item.lastname}`
                "
                :clearable="true"
              />
            </div>

            <div class="md-layout-item md-small-size-100 md-size-50">
              <validated-dropdown-input
                v-model="payloadoperatorname"
                :key="projectname + payloadoperatorname"
                :options="payloadOperators"
                label="Payload Operator"
                name="payloadoperatorname"
                placeholder="select a payload operator"
                :value-transformation="
                  item => `${item.firstname} ${item.lastname}`
                "
                :display-transformation="
                  item => `${item.firstname} ${item.lastname}`
                "
                :clearable="true"
              />
            </div>

            <div class="md-layout-item md-size-100 md-small-hide">
              <br /><br />
            </div>

            <div class="md-layout-item md-size-100">
              <validated-dropdown-input
                v-model="dronemodel"
                :key="projectname + dronemodel"
                :options="drones"
                label="RPAS"
                name="dronemodel"
                placeholder="select an RPAS"
                validation-rules="required"
                :value-transformation="item => getSelectedDrone(item)"
                :display-transformation="
                  item =>
                    item.nickname
                      ? item.nickname
                      : `${item.manufacturer} ${item.model}`
                "
                @input="droneOnSelected"
              />
            </div>

            <label
              class="md-layout-item md-small-size-100 md-size-10 md-form-label"
              >{{ $t("Registration Number") }}</label
            >
            <div class="md-layout-item md-small-size-100 md-size-35">
              <md-field>
                <md-input
                  v-model="droneregistrationnumber"
                  type="text"
                  disabled
                />
              </md-field>
            </div>

            <label
              class="md-layout-item md-small-size-100 md-size-10 md-form-label"
              >{{
                usertype === USER_TYPE.MAAC
                  ? $t("MAAC Number")
                  : $t("Drone ID / Serial Number")
              }}</label
            >
            <div class="md-layout-item md-size-35">
              <md-field>
                <md-input v-model="serialno" type="text" disabled></md-input>
              </md-field>
            </div>

            <label
              class="md-layout-item md-small-size-100 md-size-10 md-form-label"
            >
              {{ $t("Colour") }}
            </label>
            <div class="md-layout-item md-size-35">
              <md-field>
                <md-input v-model="dronecolor" type="text" disabled />
              </md-field>
            </div>

            <div class="md-layout-item md-size-100 md-small-hide">
              <br /><br />
            </div>

            <template v-if="surveyType === SURVEY_TYPE.REVIEWER">
              <div class="md-layout-item md-size-100">
                <validated-dropdown-input
                  :options="flight_schools"
                  v-model="flightSchool"
                  :label="$t('Affiliated Flight School')"
                  name="flightSchool"
                  validation-rules="required"
                  :valueTransformation="item => item"
                  :displayTransformation="item => item"
                />
              </div>

              <div class="md-layout-item md-size-100">
                <validated-dropdown-input
                  :options="bookList"
                  v-model="reviewcustomer"
                  :label="$t('Client')"
                  name="reviewcustomer"
                  validation-rules="required"
                  :valueTransformation="
                    item => `${item.customer_name}|${item.customer_email}`
                  "
                  :displayTransformation="
                    item => `${item.customer_name}(${item.customer_email})`
                  "
                />
              </div>

              <div class="md-layout-item md-size-100 md-small-hide">
                <br /><br />
              </div>
            </template>

            <div class="md-layout-item md-small-size-100 md-size-30">
              <validated-text-input
                name="operationradius"
                label="Operation Radius"
                placeholder="enter radius"
                v-model="operationradius"
                type="number"
                :validation-rules="
                  usertype === USER_TYPE.MAAC
                    ? radiusunit === 'm'
                      ? 'required|between:100,3704'
                      : 'required|between:0.054,2'
                    : radiusunit === 'm'
                      ? 'required|between:100,2000'
                      : 'required|between:0.054,1.080'
                  
                "
              />
            </div>
            <div class="md-layout-item md-small-size-100 md-size-20">
              <md-radio
                v-model="radiusunit"
                value="m"
                @change="changeRadiusUnit"
              >
                M
              </md-radio>
              <md-radio
                v-model="radiusunit"
                value="nm"
                @change="changeRadiusUnit"
              >
                {{ $t("NM") }}
              </md-radio>
            </div>

            <div class="md-layout-item md-small-size-100 md-size-50">
              <validated-text-input
                name="operationaltitude"
                label="Max Altitude AGL (ft)"
                placeholder="enter altitude"
                v-model="operationaltitude"
                type="number"
                :validation-rules="
                  usertype === USER_TYPE.MAAC
                    ? 'required|between:10,3000'
                    : 'required|between:10,700'
                "
                :mask="['#', '##', '###', '####']"
              />
            </div>
          </div>
          <br />
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import { createHelpers } from "vuex-map-fields";
import { USER_TYPE, PILOT_NETWORK, SURVEY_TYPE } from "@/const.js";
import ValidatedDropdownInput from "@/components/Inputs/ValidatedDropdownInput.vue";
import ValidatedTextInput from "@/components/Inputs/ValidatedTextInput.vue";
import { getNearTermBookings } from "@/services/flightReview.service.js";
import swal from "sweetalert2";
import { EventBus } from "@/helpers";
import { router } from "@/main";
import { getDroneInfo } from "@/store/survey.module.js";

const { mapFields } = createHelpers({
  mutationType: "updateSurveyField"
});

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    ValidatedTextInput,
    ValidatedDropdownInput
  },
  data() {
    return {
      USER_TYPE,
      drones: [],
      pilots: [],
      observers: [],
      payloadOperators: [],
      projects: [],
      bookList: [],
      PILOT_NETWORK,
      SURVEY_TYPE
    };
  },
  computed: {
    ...mapFields("auth", [
      "email",
      "usertype",
      "pilot_network",
      "flight_schools"
    ]),
    ...mapFields("survey", [
      "surveyDraft.dronemodel",
      "surveyDraft.droneregistrationnumber",
      "surveyDraft.dronecolor",
      "surveyDraft.projectname",
      "surveyDraft.serialno",
      "surveyDraft.pilotname",
      "surveyDraft.pilotfullname",
      "surveyDraft.pilotlicense",
      "surveyDraft.observername",
      "surveyDraft.payloadoperatorname",
      "surveyDraft.operationradius",
      "surveyDraft.operationaltitude",
      "surveyDraft.radiusunit",
      "surveyDraft.flightSchool",
      "surveyDraft.reviewcustomer",
      "surveyDraft.surveyType",
      "isclone"
    ]),
    projectNames() {
      return this.projects.map(project => project.name);
    }
  },
  methods: {
    onPilotSelected(pilot) {
      let drones = [...this.$store.state.setting.drones],
        _drones = [];

      if (this.projectname) {
        let projectDrones = [
          ...this.projects.find(project => project.name === this.projectname)
            .drones
        ].map(item => item.registrationnumber);
        drones = drones.filter(item =>
          projectDrones.includes(item.registrationnumber)
        );
      }

      drones.forEach(drone => {
        if (
          !drone.availability ||
          drone.availability === 0 ||
          (drone.availability === 1 && drone.pilots.includes(pilot))
        ) {
          _drones.push(drone);
        }
      });
      this.drones = _drones;
    },
    changeRadiusUnit() {
      if (this.radiusunit === "m") {
        this.operationradius = this.operationradius
          ? (parseFloat(this.operationradius) * 1852).toFixed(0)
          : "";
      } else {
        this.operationradius = this.operationradius
          ? (parseFloat(this.operationradius) / 1852).toFixed(3)
          : "";
      }
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        if (!this.serialno) {
          this.noSerialnoWarning();
          return false;
        }
        this.$emit("on-validated", res);
        return res;
      });
    },
    getSelectedDrone(drone) {
      const baseDroneInfo = `${drone.manufacturer}|${drone.model}|${drone.registrationnumber}`;
      return drone.nickname
        ? `${baseDroneInfo}|${drone.nickname}`
        : baseDroneInfo;
    },
    droneOnSelected(drone) {
      if (!drone) return;
      const droneObj = drone.split("|");
      const { serialno } = this.drones.find(
        x =>
          x.manufacturer === droneObj[0] &&
          x.model === droneObj[1] &&
          x.registrationnumber === droneObj[2]
      );
      if (!serialno) {
        this.noSerialnoWarning();
      }
    },
    noSerialnoWarning() {
      let self = this;
      swal
        .fire({
          text: this.$t(
            "Your selected drone has missing information, please update or select another drone."
          ),
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button",
          confirmButtonText: this.$t("Update"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (!result.value) {
            self.dronemodel = "";
          } else {
            const drone = self.dronemodel.split("|");
            const { droneInfo, positionDrone } = getDroneInfo(
              self.$store.state.setting.drones,
              {
                manufacturer: drone[0],
                model: drone[1],
                registrationnumber: drone[2]
              }
            );
            router.push({
              path: "/settings/drone",
              query: {
                type: "edit",
                positionDrone,
                droneInfo: JSON.stringify(droneInfo)
              }
            });
          }
        });
    },
    convertVueObject(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    updateSelectionOptionsWithSelectedProject() {
      if (this.projects.length === 0 || !this.projectname) {
        return;
      }

      const selectedProject = this.projects.find(
        project => project.name === this.projectname
      );

      if (this.usertype === USER_TYPE.PILOT) {
        this.pilots = [];
        selectedProject.pilots.forEach(pilot => {
          if (pilot.pilot && pilot.email === this.email) {
            this.pilots.push(pilot);
          }
        });
      } else if (
        this.usertype === USER_TYPE.ADMIN ||
        this.usertype === USER_TYPE.ENTERPRISE ||
        this.usertype === USER_TYPE.SUPER
      ) {
        this.pilots = this.convertVueObject(selectedProject.pilots);
      }
      this.observers = this.convertVueObject(selectedProject.observers);
      this.payloadOperators = this.convertVueObject(
        selectedProject.payloadOperators
      );
      let projectDrones = this.convertVueObject(selectedProject.drones).map(
        item => item.registrationnumber
      );
      this.drones = this.$store.state.setting.drones.filter(item =>
        projectDrones.includes(item.registrationnumber)
      );
    },
    updateSelectionOptionsWithSetting() {
      this.drones = this.$store.state.setting.drones;

      const pilots = this.$store.state.setting.pilots;
      this.pilots = [];
      if (this.usertype === USER_TYPE.PILOT) {
        pilots.forEach(pilot => {
          if (pilot.pilot && pilot.email === this.email) {
            this.pilots.push(pilot);
          }
        });
      } else {
        pilots.forEach(pilot => {
          if (pilot.pilot) {
            this.pilots.push(pilot);
          }
        });
      }
      this.observers = [];
      pilots.forEach(pilot => {
        if (pilot.observer) {
          this.observers.push(pilot);
        }
      });
      this.payloadOperators = [];
      pilots.forEach(pilot => {
        if (pilot.payloadOperator) {
          this.payloadOperators.push(pilot);
        }
      });
    },
    async getNearTermBookings() {
      this.bookList = await getNearTermBookings();
    },
    checkSurveyType(pilotNetwork) {
      if (
        [PILOT_NETWORK.REVIEWER, PILOT_NETWORK.MAAC_REVIEWER, PILOT_NETWORK.PUBLIC_SERVICE_REVIEWER].indexOf(
          pilotNetwork
        ) > -1
      ) {
        swal
          .fire({
            text: this.$t("Please select the type of your new mission:"),
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonClass: "md-button md-success",
            cancelButtonClass: "md-button md-success",
            confirmButtonText: this.$t("Regular"),
            cancelButtonText: this.$t("Flight Review"),
            buttonsStyling: false
          })
          .then(result => {
            if (!result.value) {
              this.$store.commit("survey/setSurvetType", SURVEY_TYPE.REVIEWER);
              this.getNearTermBookings();
            } else {
              this.$store.commit("survey/setSurvetType", SURVEY_TYPE.REGULAR);
            }
          });
      }
    },
    onSettingChange() {
      const projects = this.$store.state.setting.projects;
      if (this.usertype === USER_TYPE.PILOT) {
        this.projects = projects.filter(project =>
          project.pilots.some(pilot => pilot.email === this.email)
        );
      } else if (
        this.usertype === USER_TYPE.ADMIN ||
        this.usertype === USER_TYPE.ENTERPRISE ||
        this.usertype === USER_TYPE.SUPER
      ) {
        this.projects = projects;
      }
      if (this.projectname && this.projects.length) {
        this.updateSelectionOptionsWithSelectedProject();
        return;
      }
      this.updateSelectionOptionsWithSetting();
    }
  },
  watch: {
    projectname(newValue) {
      if (newValue && this.projects.length) {
        this.updateSelectionOptionsWithSelectedProject();
        return;
      }
      this.updateSelectionOptionsWithSetting();
    }
  },
  beforeMount() {
    if (this.isclone) {
      this.$store.dispatch("setting/getSettings").then(() => {
        this.onSettingChange();
      });
    } else {
      this.$store.dispatch("survey/getSurveyDraft").then(() => {
        this.$store.dispatch("setting/getSettings").then(() => {
          this.onSettingChange();
        });
      });
    }

    this.checkSurveyType(this.pilot_network);
    EventBus.$on("getUserProfile", () => {
      this.checkSurveyType(this.pilot_network);
    });
  },
  destroyed() {
    EventBus.$off("getUserProfile");
  }
};
</script>

<style lang="css">
.md-select .md-icon.md-icon-image svg {
  display: none;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
